<template>
	<div class="call-to-action" ref="cta">
		<div class="call-to-action--content">
			<div class="call-to-action--content--copy">
				<Heading
					shuffle
					:viewable="viewable"
					loop
					spaced
					glow
					:text="title"
				></Heading>
				<p v-if="text">
					{{ text }}
				</p>
				<div class="call-to-action--content--button">
					<Button :href="href">{{ buttonLabel }}</Button>
				</div>
			</div>
			<div class="vertical-line"></div>
		</div>

		<div class="call-to-action--overlay"></div>
	</div>
</template>
<script>
import Heading from '@/components/Heading';
import Button from '@/components/Button';
import { useTransitionComposable } from '../../composables/transition-composable';
import { ref, watch, onUnmounted } from 'vue';
import { gsap } from 'gsap';

const { transitionState } = useTransitionComposable();

export default {
	name: 'CallToAction',
	components: {
		Heading,
		Button,
	},
	data() {
		return {
			inView: false,
		};
	},
	props: {
		title: {
			type: String,
			default: 'Title',
		},
		text: {
			type: String,
			default: null,
		},
		href: {
			type: String,
			default: '#',
		},

		buttonLabel: {
			type: String,
			default: 'View',
		},
	},
	setup() {
		const main = ref();
		const cta = ref(null);
		const viewable = ref(false);
		let tl = ref();
		let ctx = ref();
		watch(
			[() => transitionState.transitionComplete, cta],
			(newValue) => {
				if (newValue[0] == true && cta.value) {
					ctx = gsap.context(() => {
						const el = cta.value;
						tl.value = gsap.timeline({
							scrollTrigger: {
								trigger: el,
								start: 'top center+=100px',
								end: 'bottom bottom',
								scrub: 1,
							},
						});
						tl.value.fromTo(
							el.querySelector('.call-to-action--overlay'),
							{ display: 'none', opacity: 0 },
							{
								display: 'block',
								opacity: 1,
								duration: 1,
							},
						);
						tl.value.fromTo(
							el.querySelector('.vertical-line'),
							{
								transform: 'scaleY(0)',
							},
							{
								transform: 'scaleY(1)',
								duration: 1,
							},
							'-=1',
						);
						tl.value.fromTo(
							el.querySelector('.call-to-action--content--copy'),
							{ y: 70, opacity: 0 },
							{
								y: 0,
								opacity: 1,
								duration: 1,
								onStart: () => {
									viewable.value = true;
								},
							},
						);
					}, main.value);
				}
			},
			{
				immediate: true,
			},
		);
		onUnmounted(() => {
			ctx.revert(); // <- Easy Cleanup!
			tl.value.kill();
		});
		return { cta, viewable }; // WILL NOT WORK WITHOUT THIS
	},
};
</script>
